module.exports = __webpack_public_path__ + "static/media/success.93013d07.svg";